import { Plus } from 'lucide-react'
import { Box, Button } from '@mui/material'
import type { LicenseRow } from '../../types/onboarding'
import { useOnboarding } from '../../context/OnboardingContext'
import { MISC_PRIMARY } from '../../theme/onboardingTheme'

type LicenseAddMoreButtonProps = {
  createRow: () => LicenseRow
  label?: string
}

export function LicenseAddMoreButton({
  createRow,
  label = 'Add More',
}: LicenseAddMoreButtonProps) {
  const { dispatch } = useOnboarding()

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 1 }}>
      <Button
        type="button"
        onClick={() => dispatch({ type: 'ADD_LICENSE', row: createRow() })}
        startIcon={<Plus size={16} aria-hidden />}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.75,
          borderRadius: '8px',
          border: `1px solid ${MISC_PRIMARY}66`,
          backgroundColor: '#ffffff',
          px: 2,
          py: 1,
          fontSize: 14,
          fontWeight: 600,
          color: MISC_PRIMARY,
          boxShadow: 1,
          textTransform: 'none',
          '&:hover': { backgroundColor: '#eff6ff' },
        }}
      >
        {label}
      </Button>
    </Box>
  )
}
